import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../../utils/analytics';
import { generateHash } from '../../../utils/hash';
import { useSelector } from "react-redux";

const PageViewTracker = () => {
  const location = useLocation();

  const userLoginState = useSelector(
    (state) => state.authentication.auth.loginToken
  );

  const pageType= {
      "/" : "homePage",
      "/minha-conta": "authenticatedArea",
      "/regulamento": "promoRequirements",
      "/cadastre-se": "signUpArea",
      "/cadastre-se/passo-1/verificacao-email": "registerPromoArea",
      "/cadastre-se/passo-1/dados-pessoais": "registerPromoArea",
      "/cadastre-se/passo-1/bebe": "registerPromoArea",
      "/cadastro-complementar": "registerPromoArea",
      "/cadastre-se/passo-1/dados-contato": "registerPromoArea",
      "/cadastro-promo/sucesso": "successPromoRegister"
  }
  
  useEffect(() => {
    const page_path = location.pathname + location.search;
    let currentTitle = document.title;
    
    const sendPageView = () => {
      trackPageView({
        page_id: `pt-BR:${generateHash(page_path)}`,
        page_name: document.title,
        page_type: pageType[location.pathname] || "genericPage",
        user_login_state: userLoginState ? "authenticated" : "anonymous",
      });
    };
  
    const observer = new MutationObserver(() => {
      if (document.title !== currentTitle) {
        currentTitle = document.title;
        sendPageView();
      }
    });
  
    observer.observe(document.querySelector('title'), { childList: true });
  
    sendPageView();
  
    return () => observer.disconnect();
  }, [location]);


  return null;
};

export default PageViewTracker;
